import React from "react";

const ModalGenerateScriptSkeleton = () => {
  return (
    <div className="animate-pulse">
      <div className="bg-white border border-[#E4E7EC] px-3 py-0.5 items-center gap-1 rounded-lg inline-flex mb-5">
        <div className="w-4 h-4 bg-gray-300 rounded"></div>
        <div className="w-16 h-3 bg-gray-300 rounded"></div>
      </div>

      <div className="text-center mb-5">
        <p className="text-base font-semibold text-gray-700">
          Generating script
          <span className="inline-block animate-bounce">.</span>
          <span className="inline-block animate-bounce [animation-delay:200ms]">
            .
          </span>
          <span className="inline-block animate-bounce [animation-delay:400ms]">
            .
          </span>
        </p>
      </div>

      <div className="flex justify-center items-center gap-x-2 flex-wrap mb-5">
        {[1, 2, 3].map((index) => (
          <div
            key={index}
            className="flex items-center gap-x-2 px-2 py-1 rounded-[4px] bg-gray-200 h-8 w-20"
          ></div>
        ))}
      </div>

      <div className="mb-5">
        <div className="w-48 h-6 bg-gray-300 rounded mb-4"></div>
        <div className="flex gap-x-5">
          <div className="w-32 h-6 bg-gray-200 rounded-lg"></div>
          <div className="w-24 h-6 bg-gray-200 rounded-lg"></div>
        </div>
      </div>

      <div className="flex items-center gap-x-4 mb-5">
        <div className="flex gap-1 items-center pb-2">
          <div className="w-4 h-4 bg-gray-300 rounded"></div>
          <div className="w-20 h-3 bg-gray-300 rounded"></div>
        </div>
        <div className="flex gap-1 items-center pb-2">
          <div className="w-4 h-4 bg-gray-300 rounded"></div>
          <div className="w-24 h-3 bg-gray-300 rounded"></div>
        </div>
      </div>

      {[1, 2, 3, 4].map((index) => (
        <div
          key={index}
          className="border border-[#DDDDDD] rounded-lg p-3 mt-5"
        >
          <div className="flex justify-between items-center mb-3">
            <div className="w-16 h-4 bg-gray-300 rounded"></div>
            <div className="w-12 h-6 bg-gray-200 rounded"></div>
          </div>
          <div className="space-y-2">
            <div className="w-full h-3 bg-gray-200 rounded"></div>
            <div className="w-3/4 h-3 bg-gray-200 rounded"></div>
            <div className="w-1/2 h-3 bg-gray-200 rounded"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ModalGenerateScriptSkeleton;
